module.exports = __webpack_public_path__ + "img/commonButtonActive.6b51e619.png";